export default __webpack_public_path__ + "static/media/ricepaper.010de633.png";